

































































































import { Component, Vue, Watch, Inject } from 'vue-property-decorator';
import checkout from '@/store/modules/checkout';
import { Validator } from 'vee-validate';
import {QuoteAddressInvoiceRequest, RequestInvoicePayload} from '@/store/models';
import Datepicker from 'vue2-datepicker';
import { datepickerLocales } from '@/i18n';
import store from '@/store';

@Component({
  components: {
    Datepicker,
  },
})
export default class RequestInvoice extends Vue {
  @Inject() public $validator!: Validator;

  @Watch('requestInvoice.enabled')
  private onRequestInvoiceUnselect(val: any, oldVal: any) {
    if (!val && val !== oldVal) {
      this.requestInvoice = {
        cfpiva: '',
        dateofbirth: '',
        enabled: false,
        gender: '',
        placeofbirth: '',
      };
      this.save(this.requestInvoice);
    }
  }

  get fulfilled(): boolean {
    return checkout.stepByName('invoice').fulfilled;
  }

  get openDate() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return (this.requestInvoice.dateofbirth == null || this.requestInvoice.dateofbirth == '') ? date : '';
  }

  private disabledDobs(date: Date): boolean {
    const dateDob = new Date();
    dateDob.setFullYear(dateDob.getFullYear() - 18);
    return date > dateDob;
  }

  get dateFormat(): string {
    return store.state.options.dateFormat.toUpperCase();
  }

  get lang(): string {
    return datepickerLocales[store.state.options.locale];
  }

  get requestInvoice(): any {
    const addr = checkout.billingAddress;
    return addr.extension_attributes ? addr.extension_attributes.invoicerequest : {};
  }

  set requestInvoice(value: any) {
    checkout.setRequestInvoice(value);
  }

  private async save(requestInvoice: QuoteAddressInvoiceRequest) {
    const payload: RequestInvoicePayload = {
      requestInvoice: {
        tdy_request_invoice: requestInvoice.enabled,
        tdy_request_invoice_vat_id: requestInvoice.cfpiva,
        tdy_request_invoice_gender: requestInvoice.gender,
        tdy_request_invoice_dob: requestInvoice.dateofbirth,
        tdy_request_invoice_pob: requestInvoice.placeofbirth,
      },
    };
    await checkout.assignRequestInvoice(payload);
  }
}
